package amazon.lastmile.inject

import app.nestbridge.app.presenter.AppPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = AppPresenterFactory::class)
public interface AppNestbridgeAppPresenterAppPresenterFactory {
  @Provides
  @IntoSet
  public fun provideAppPresenterFactoryFactoryMultibinding(appPresenterFactory: AppPresenterFactory): Presenter.Factory = appPresenterFactory
}
